import { Stack, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import { ChatComposer } from "web_myplann/Chat/Components/ChatComposer";
import { ChatEmptyState } from "web_myplann/Chat/Components/ChatEmptyState";
import { ChatHeader } from "web_myplann/Chat/Components/ChatHeader";
import { ChatMessageList } from "web_myplann/Chat/Components/ChatMessageList";
import { ChatSkeleton } from "web_myplann/Chat/Components/ChatSkeleton";
import { useChatPage } from "web_myplann/Chat/Hooks/useChatPage";
import { useChatScrollAnchor } from "web_myplann/Chat/Hooks/useChatScrollAnchor";

export const ChatPage = () => {
	const theme = useTheme();
	const scrollRef = useRef<HTMLDivElement>(null);
	const hasAnchoredRef = useRef(false);
	const anchorToBottom = useChatScrollAnchor(scrollRef);
	const {
		advisorName,
		advisorPhoto,
		messages,
		isLoading,
		hasOlder,
		isLoadingOlder,
		loadOlder,
		input,
		setInput,
		onSend,
		onRetry,
		onPickPhoto,
		onPickGallery,
		onPickFile,
		onBack,
	} = useChatPage({ onMessageSent: anchorToBottom });

	useEffect(() => {
		if (hasAnchoredRef.current || messages.length === 0) return;
		hasAnchoredRef.current = true;
		anchorToBottom();
	}, [messages.length, anchorToBottom]);

	const hasMessages = messages.length > 0;

	return (
		<Stack height="100dvh" bgcolor={theme.palette.background.paper}>
			<ChatHeader name={advisorName} photo={advisorPhoto} onBack={onBack} />

			<Stack
				ref={scrollRef}
				flex={1}
				minHeight={0}
				px={1.2}
				py={1.2}
				bgcolor={theme.palette.surface.muted}
				sx={{ overflowY: "auto" }}
			>
				{isLoading ? (
					<ChatSkeleton />
				) : hasMessages ? (
					<ChatMessageList
						messages={messages}
						advisorName={advisorName}
						advisorPhoto={advisorPhoto}
						hasOlder={hasOlder}
						isLoadingOlder={isLoadingOlder}
						onLoadOlder={loadOlder}
						onRetry={onRetry}
					/>
				) : (
					<ChatEmptyState />
				)}
			</Stack>

			<ChatComposer
				value={input}
				onChange={setInput}
				onSend={onSend}
				onPickPhoto={onPickPhoto}
				onPickGallery={onPickGallery}
				onPickFile={onPickFile}
			/>
		</Stack>
	);
};
